import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { Indicador, IndicadoresTipo, ListaIndicadores } from '../../../pagesPublic';
import { ROUTES_INDICADORES_TIPO } from '../../../enums';

const IndicadoresRoutes = () => {
  return (
    <Routes>
      {Object.keys(ROUTES_INDICADORES_TIPO).map(pRoute => (
        <React.Fragment key={pRoute}>
          <Route exact path={`${pRoute}/page/:page`} element={<IndicadoresTipo />} />
          <Route exact path={pRoute} element={<IndicadoresTipo />} />
        </React.Fragment>
      ))}
      <Route exact path=":id/*" element={<Indicador />} />
      <Route path="*" element={<ListaIndicadores />} />
    </Routes>
  );
};

export default IndicadoresRoutes;
